<template>
    <div class="row  mw820 margin-top-50" dir="rtl" >
      <div class="f22-l30-b df36-l30-b red text-center">{{data.title}}</div>
      <div class="col-4 text-center" v-for="(icon,idx) in data.icons" :key="idx">
          <SvgImage :src="icon.href" clazz="center  margin-bottom-20" class="yummi_preview_icon"></SvgImage>
      </div>
  </div>
</template>
<script>
import SvgImage from "@/components/generic/SvgImage";
export default {
  components: {
    SvgImage,
  },
  props: {
    data: Object
  },
}
</script>
<style scoped>
  .yummi_preview_icon {
    height: 100px;
    width: 100px;
  }

  @media (min-width: 1200px){
    .yummi_preview_icon {
      height: 200px;
      width: 200px;
    }
  }
</style>